import React, {Component, lazy, Suspense} from 'react'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import {NavDropdown} from "react-bootstrap";
import Container from 'react-bootstrap/Container'
import LocalizedStrings from 'react-localization';
import {DEFAULT_LANGUAGE, CZECH_LANGUAGE} from "./App";
import axios from "axios";
import api from '../api/axios';
import Cookies from 'js-cookie';
import { googleLogout, GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_CLIENT_ID } from './constants';

const AuthModal = lazy(() => import('./AuthModal'));

export default class Header extends Component {
	constructor(props) {
		super(props);
		let localizedGeneralInfos = new LocalizedStrings({
			vn: {
				login: 'Đăng nhập',
				register: 'Đăng ký',
                logout: 'Đăng xuất',
                savedSearches: 'Danh mục tìm kiếm đã lưu',
                favorites: 'Yêu thích',
			},
			cz: {
				login: 'Přihlásit se',
				register: 'Registrace',
                logout: 'Odhlásit se',
                savedSearches: 'Uložené kategorie vyhledávání',
                favorites: 'Oblíbené',
			}
		});

		const favCount = (() => {
			try { return JSON.parse(localStorage.getItem('pn_favorites') || '[]').length; }
			catch { return 0; }
		})();

		this.state = {
			actualLang: DEFAULT_LANGUAGE,
			secondLang: '',
			actualLangImageSrc: '/static/images/vietnam_flag.svg',
			secondLangImageSrc: '',
			lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : DEFAULT_LANGUAGE,
			localizedGeneralInfos: localizedGeneralInfos,
			showAuthModal: false,
			authModalView: 'login',
			authKey: 0,
			menuOpen: false,
			userMenuOpen: false,
			favCount,
			oauthProviderMounted: false,
		}
		this.userMenuRef = React.createRef();
		this.handleOutsideClick = this.handleOutsideClick.bind(this);
	}

	componentDidMount() {
		const lang = this.state.lang;
		// Sync current language to cookie so Django template pages pick it up correctly
		document.cookie = 'lang=' + lang + ';path=/;max-age=31536000';
		// Hide the static placeholder header now that React has rendered the real one
		const placeholder = document.getElementById('static-header-placeholder');
		if (placeholder) placeholder.style.display = 'none';
		// Auto-open login modal when redirected from a Django service page via ?login=1
		if (new URLSearchParams(window.location.search).get('login') === '1') {
			this.setState({ showAuthModal: true, authModalView: 'login', oauthProviderMounted: true });
			window.history.replaceState({}, '', window.location.pathname);
		}
		const actualLangImageSrc = (lang === DEFAULT_LANGUAGE ?
			'/static/images/vietnam_flag.svg' :
			'/static/images/czech_flag.svg');
		const secondLangImageSrc = (lang === DEFAULT_LANGUAGE ?
			'/static/images/czech_flag.svg' :
			'/static/images/vietnam_flag.svg');
		this.setState({ actualLangImageSrc, secondLangImageSrc });

		// Preload both flags so the dropdown image appears instantly on mobile
		['/static/images/vietnam_flag.svg', '/static/images/czech_flag.svg'].forEach(src => {
			const img = new window.Image();
			img.src = src;
		});

		const params = new URLSearchParams(window.location.search);
		if (params.get('new-password-set') != null && sessionStorage.getItem('loggedIn') !== 'true') {
			this.setState({ showAuthModal: true, authModalView: 'login', oauthProviderMounted: true });
		}

		// Restore session from cookie on page load
		if (sessionStorage.getItem('loggedIn') !== 'true' || sessionStorage.getItem('isPartner') === null) {
			api.get('/auth/me/').then(response => {
				if (!response.data.authenticated) return;
				const { email, first_name, last_name, is_superuser, is_partner } = response.data;
				sessionStorage.setItem('loggedIn', 'true');
				sessionStorage.setItem('email', email);
				sessionStorage.setItem('firstName', first_name);
				sessionStorage.setItem('lastName', last_name);
				sessionStorage.setItem('isSuperuser', is_superuser);
				sessionStorage.setItem('isPartner', is_partner);
				this.forceUpdate();
			});
		}

		this._onAuthChanged = () => this.setState({ authKey: Date.now() });
		window.addEventListener('auth-changed', this._onAuthChanged);
		this._onOpenAuthModal = (e) => this.setState({ showAuthModal: true, authModalView: e.detail?.view || 'login' });
		window.addEventListener('open-auth-modal', this._onOpenAuthModal);
		this._onFavChanged = (e) => this.setState({ favCount: e.detail?.count ?? 0 });
		window.addEventListener('pn-favorites-changed', this._onFavChanged);
		document.addEventListener('click', this.handleOutsideClick);
	}

	componentWillUnmount() {
		window.removeEventListener('auth-changed', this._onAuthChanged);
		window.removeEventListener('open-auth-modal', this._onOpenAuthModal);
		window.removeEventListener('pn-favorites-changed', this._onFavChanged);
		document.removeEventListener('click', this.handleOutsideClick);
	}

	handleOutsideClick(e) {
		if (this.userMenuRef.current && !this.userMenuRef.current.contains(e.target)) {
			this.setState({ userMenuOpen: false });
		}
	}

	changeLanguage(lang) {
		localStorage.setItem('lang', lang);
		document.cookie = 'lang=' + lang + ';path=/;max-age=31536000';
		this.setState({ lang });
		const actualLangImageSrc = (lang === DEFAULT_LANGUAGE ?
			'/static/images/vietnam_flag.svg' :
			'/static/images/czech_flag.svg');
		const secondLangImageSrc = (lang === DEFAULT_LANGUAGE ?
			'/static/images/czech_flag.svg' :
			'/static/images/vietnam_flag.svg');
		this.setState({ actualLangImageSrc, secondLangImageSrc });
		window.location.reload();
	}

    handleLogout() {
        // Clear Facebook session if logged in via FB
        if (window.FB) {
            window.FB.getLoginStatus(response => {
                if (response.status === 'connected') {
                    window.FB.logout(() => {});
                }
            });
        }

        // Clear Google session
        googleLogout();

        axios({
            method: 'POST',
            url: '/auth/logout/',
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true,
        })
        .finally(() => {
            sessionStorage.setItem('loggedIn', 'false');
            sessionStorage.removeItem('firstName');
            sessionStorage.removeItem('lastName');
            sessionStorage.removeItem('email');
            sessionStorage.removeItem('isPartner');
            window.location.reload();
        });
    }

	render() {
		let lang = this.state.lang;
		let localizedGeneralInfos = this.state.localizedGeneralInfos;
		localizedGeneralInfos.setLanguage(lang);
        const servicesLabel = lang === 'vn' ? 'Dịch vụ liên quan' : 'Související služby';
        const mgmtLabel = lang === 'vn' ? 'Quản lý căn hộ' : 'Správa bytů';
        const mortgageLabel = lang === 'vn' ? 'Tư vấn vay thế chấp' : 'Hypoteční poradenství';
        const legalLabel = lang === 'vn' ? 'Dịch vụ pháp lý' : 'Právní servis';
        const translationLabel = lang === 'vn' ? 'Dịch vụ phiên dịch' : 'Překladatelská služba';
        const valuationLabel = lang === 'vn' ? 'Thẩm định giá BĐS' : 'Odhad ceny nemovitosti';
        const buyoutLabel = lang === 'vn' ? 'Mua lại bất động sản' : 'Výkup nemovitosti';
        const renovationLabel = lang === 'vn' ? 'Cải tạo bất động sản' : 'Rekonstrukce nemovitosti';
        const constructionLabel = lang === 'vn' ? 'Dịch vụ xây dựng' : 'Stavební práce';
        const moneyTransferLabel = lang === 'vn' ? 'Chuyển tiền VN → Séc' : 'Převod peněz VN → ČR';
        const firstName = sessionStorage.getItem('firstName') ? sessionStorage.getItem('firstName') : '';
        const lastName = sessionStorage.getItem('lastName') ? sessionStorage.getItem('lastName') : '';
        const email = sessionStorage.getItem('email') ? sessionStorage.getItem('email') : '';
        let abbreviation = '';

        if (firstName !== '' && lastName !== '') {
            abbreviation = Array.from(firstName)[0].toUpperCase() + Array.from(lastName)[0].toUpperCase()
        } else if (email){
            abbreviation = (Array.from(email)[0] + Array.from(email)[1]).toUpperCase();
        } else {
            abbreviation = 'BV';
        }

        const { menuOpen } = this.state;
        const services = [
            { href: '/property-management/', icon: '🏠', label: mgmtLabel },
            { href: '/mortgage-service/',    icon: '🏦', label: mortgageLabel },
            { href: '/legal-service/',       icon: '📋', label: legalLabel },
            { href: '/translation-service/', icon: '🌐', label: translationLabel },
            { href: '/valuation-service/',   icon: '📊', label: valuationLabel },
            { href: '/buyout-service/',      icon: '🏷️', label: buyoutLabel },
            { href: '/renovation-service/',   icon: '🔨', label: renovationLabel },
            { href: '/construction-service/', icon: '🏗️', label: constructionLabel },
            { href: '/money-transfer/',       icon: '💸', label: moneyTransferLabel },
        ];

		return(
			<header className={'header'}>
				{this.state.oauthProviderMounted && (
					<GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID} locale={lang === 'vn' ? 'vi' : 'cs'}>
					{this.state.showAuthModal && (
						<Suspense fallback={null}>
							<AuthModal
								show={this.state.showAuthModal}
								onHide={() => this.setState({ showAuthModal: false })}
								initialView={this.state.authModalView}
								onSuccess={() => {
									this.setState({ showAuthModal: false, authKey: Date.now() });
								}}
							/>
						</Suspense>
					)}
					</GoogleOAuthProvider>
				)}
				<Navbar bg="white" variant="light">
                    <Container className={'header-container'}>

                        {/* Logo */}
                        <Navbar.Brand className={'brand'} href="/">
                            <picture>
                                <source srcSet="/static/images/logo.webp" type="image/webp" />
                                <img src="/static/images/logo.png" alt="Prahanoi" height="48" />
                            </picture>
                        </Navbar.Brand>

                        {/* Right section */}
                        <div className="d-flex align-items-center ms-auto header-actions">

                            {/* Services dropdown — desktop only */}
                            <NavDropdown
                                title={servicesLabel}
                                id="services-dropdown"
                                className="header-services-dropdown d-none d-sm-block"
                                align="end"
                            >
                                {services.map(s => (
                                    <NavDropdown.Item key={s.href} href={s.href}>
                                        {s.icon} {s.label}
                                    </NavDropdown.Item>
                                ))}
                            </NavDropdown>

                            {/* Favorites — always visible */}
                            <a
                                href="/oblibene/"
                                className="pn-favorites-btn"
                                title={localizedGeneralInfos.favorites}
                                aria-label={localizedGeneralInfos.favorites}
                            >
                                <svg width="18" height="18" viewBox="0 0 24 24" fill={this.state.favCount > 0 ? 'var(--accent)' : 'none'} stroke={this.state.favCount > 0 ? 'var(--accent)' : 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                                </svg>
                                {this.state.favCount > 0 && (
                                    <span className="pn-favorites-badge">{this.state.favCount}</span>
                                )}
                            </a>

                            {/* Lang flags — always visible */}
                            <div className="lang-switcher">
                                <button
                                    className={`lang-flag-btn${lang === DEFAULT_LANGUAGE ? ' lang-flag-active' : ''}`}
                                    onClick={() => lang !== DEFAULT_LANGUAGE && this.changeLanguage(DEFAULT_LANGUAGE)}
                                    title="Tiếng Việt"
                                >
                                    <img src="/static/images/vietnam_flag.svg" width="28" height="21" alt="Tiếng Việt" />
                                </button>
                                <button
                                    className={`lang-flag-btn${lang === CZECH_LANGUAGE ? ' lang-flag-active' : ''}`}
                                    onClick={() => lang !== CZECH_LANGUAGE && this.changeLanguage(CZECH_LANGUAGE)}
                                    title="Česky"
                                >
                                    <img src="/static/images/czech_flag.svg" width="28" height="21" alt="Česky" />
                                </button>
                            </div>

                            {/* Login — always visible */}
                            {sessionStorage.getItem('loggedIn') !== 'true' &&
                                <Nav>
                                    <Nav.Link onClick={() => this.setState({ showAuthModal: true, authModalView: 'login', oauthProviderMounted: true })} style={{ cursor: 'pointer' }} aria-label={localizedGeneralInfos.login}>
                                        <svg width="14" height="14" viewBox="0 0 448 512" fill="currentColor" style={{verticalAlign:'middle', marginTop:'-2px'}} aria-hidden="true"><path d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"/></svg>
                                        <span className="d-none d-lg-inline"> {localizedGeneralInfos.login}</span>
                                    </Nav.Link>
                                </Nav>
                            }

                            {/* Avatar — logged in */}
                            {sessionStorage.getItem('loggedIn') === 'true' &&
                                <div className="pn-user-menu" ref={this.userMenuRef}>
                                    <button
                                        className="pn-user-avatar"
                                        onClick={(e) => { e.stopPropagation(); this.setState(s => ({ userMenuOpen: !s.userMenuOpen })); }}
                                        title={`${firstName} ${lastName}`}
                                    >
                                        {abbreviation}
                                    </button>
                                    <div className={`pn-user-dropdown${this.state.userMenuOpen ? ' open' : ''}`}>
                                        <div className="pn-user-dropdown__info">
                                            <span className="pn-user-dropdown__abbr">{abbreviation}</span>
                                            <div style={{minWidth: 0, overflow: 'hidden'}}>
                                                <div className="pn-user-dropdown__name">{firstName} {lastName}</div>
                                                <div className="pn-user-dropdown__email">{email}</div>
                                            </div>
                                        </div>
                                        <hr className="pn-user-dropdown__divider" />
                                        <a href="/auth/watchdog/list/" className="pn-user-dropdown__item">
                                            {localizedGeneralInfos.savedSearches}
                                        </a>
                                        {sessionStorage.getItem('isPartner') === 'true' && <>
                                            <hr className="pn-user-dropdown__divider" />
                                            <a href="/partner/dashboard/" className="pn-user-dropdown__item">
                                                {lang === 'vn' ? 'Bảng điều khiển của đối tác' : 'Partner dashboard'}
                                            </a>
                                        </>}
                                        <hr className="pn-user-dropdown__divider" />
                                        <button
                                            className="pn-user-dropdown__item pn-user-dropdown__item--logout"
                                            onClick={() => this.handleLogout()}
                                        >
                                            {localizedGeneralInfos.logout}
                                        </button>
                                    </div>
                                </div>
                            }

                            {/* Hamburger — mobile only, shows services */}
                            <button
                                className="header-hamburger d-sm-none"
                                onClick={() => this.setState({ menuOpen: !menuOpen })}
                                aria-label="Menu"
                                aria-expanded={menuOpen}
                            >
                                <span /><span /><span />
                            </button>
                        </div>

                    </Container>
				</Navbar>

                {/* Mobile services drawer */}
                {menuOpen && (
                    <>
                        <div
                            className="header-drawer-backdrop"
                            onClick={() => this.setState({ menuOpen: false })}
                        />
                        <div className="header-drawer">
                            <div className="header-drawer__label">{servicesLabel}</div>
                            {services.map(s => (
                                <a key={s.href} href={s.href} className="header-drawer__item">
                                    <span className="header-drawer__icon">{s.icon}</span>
                                    {s.label}
                                </a>
                            ))}
                        </div>
                    </>
                )}
			</header>
		)
	}
}

